import {HttpClient, RequestParams} from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import {ICampaignQuery} from "../../models/campaign/query";
import {ICampaign, ICampaignDetails} from "../../models/campaign/response";
import {ICreateCampaign, IUpdateCampaign} from "../../models/campaign/request";

class CampaignService<SecurityDataType = unknown> {
    http: HttpClient<SecurityDataType>;

    constructor(http: HttpClient<SecurityDataType>) {
        this.http = http;
    }

    getAllCampaigns = (query: ICampaignQuery, params?: RequestParams) =>
        this.http.request<IBaseListingResponse<ICampaign>>({
            path: `/campaigns`,
            method: "GET",
            query,
            ...params,
        });

    getCampaign = (id: number, params?: RequestParams) =>
        this.http.request<ICampaignDetails>({
            path: `/campaigns/${id}`,
            method: "GET",
            ...params,
        });

    createCampaign = (data: ICreateCampaign, params?: RequestParams) =>
        this.http.request<ICampaign>({
            path: "/campaigns",
            method: "POST",
            body: data,
            ...params,
        });

    updateCampaign = (id: number, data: IUpdateCampaign, params?: RequestParams) =>
        this.http.request<ICampaign>({
            path: `/campaigns/${id}`,
            method: "PUT",
            body: data,
            ...params,
        });

    deleteCampaign = (id: number, params?: RequestParams) =>
        this.http.request<ICampaign>({
            path: `/campaigns/${id}`,
            method: "DELETE",
            ...params,
        });
}

export default CampaignService;